import {
  ADD_SCHOOL,
  ADD_SCHOOL_SUCCESS,
  ADD_SCHOOL_ERROR,

  GET_PROGRAMS,
  GET_PROGRAMS_SUCCESS,
  GET_PROGRAMS_ERROR,

  GET_FIELD_OF_STUDY,
  GET_FIELD_OF_STUDY_SUCCESS,
  GET_FIELD_OF_STUDY_ERROR,

  GET_CURRENCY,
  GET_CURRENCY_SUCCESS,
  GET_CURRENCY_ERROR,

  GET_QUALIFICATION,
  GET_QUALIFICATION_SUCCESS,
  GET_QUALIFICATION_ERROR,

  GET_STUDY_LEVEL,
  GET_STUDY_LEVEL_SUCCESS,
  GET_STUDY_LEVEL_ERROR,

  GET_SCHOOL_FOS,
  GET_SCHOOL_FOS_SUCCESS,
  GET_SCHOOL_FOS_ERROR,

  ADD_SCHOOL_PROGRAM,
  ADD_SCHOOL_PROGRAM_SUCCESS,
  ADD_SCHOOL_PROGRAM_ERROR,

  DELETE_SCHOOL_PROGRAM,
  DELETE_SCHOOL_PROGRAM_SUCCESS,
  DELETE_SCHOOL_PROGRAM_ERROR,

  ADD_SCHOOL_FOS,
  ADD_SCHOOL_FOS_SUCCESS,
  ADD_SCHOOL_FOS_ERROR,

  DELETE_SCHOOL_FOS,
  DELETE_SCHOOL_FOS_SUCCESS,
  DELETE_SCHOOL_FOS_ERROR,
} from "../actions";

export const addSchool = (student, history) => ({
  type: ADD_SCHOOL,
  payload: { student, history }
});

export const addSchoolSuccess = student => ({
  type: ADD_SCHOOL_SUCCESS,
  payload: { student }
});
export const addSchoolError = message => ({
  type: ADD_SCHOOL_ERROR,
  payload: { message }
});

export const getPrograms = (student, history) => ({
  type: GET_PROGRAMS,
  payload: { student, history }
});

export const getProgramsSuccess = student => ({
  type: GET_PROGRAMS_SUCCESS,
  payload: { student }
});
export const getProgramsError = message => ({
  type: GET_PROGRAMS_ERROR,
  payload: { message }
});


export const getFos = (student, history) => ({
  type: GET_FIELD_OF_STUDY,
  payload: { student, history }
});

export const getFosSuccess = student => ({
  type: GET_FIELD_OF_STUDY_SUCCESS,
  payload: { student }
});
export const getFosError = message => ({
  type: GET_FIELD_OF_STUDY_ERROR,
  payload: { message }
});


export const getCurrency = (student, history) => ({
  type: GET_CURRENCY,
  payload: { student, history }
});

export const getCurrencySuccess = student => ({
  type: GET_CURRENCY_SUCCESS,
  payload: { student }
});
export const getCurrencyError = message => ({
  type: GET_CURRENCY_ERROR,
  payload: { message }
});

export const getQualification = (student, history) => ({
  type: GET_QUALIFICATION,
  payload: { student, history }
});

export const getQualificationSuccess = student => ({
  type: GET_QUALIFICATION_SUCCESS,
  payload: { student }
});
export const getQualificationError = message => ({
  type: GET_QUALIFICATION_ERROR,
  payload: { message }
});

export const getStudyLevel = (student, history) => ({
  type: GET_STUDY_LEVEL,
  payload: { student, history }
});

export const getStudyLevelSuccess = student => ({
  type: GET_STUDY_LEVEL_SUCCESS,
  payload: { student }
});
export const getStudyLevelError = message => ({
  type: GET_STUDY_LEVEL_ERROR,
  payload: { message }
});


export const getSchoolFOS = (student, history) => ({
  type: GET_SCHOOL_FOS,
  payload: { student, history }
});

export const getSchoolFOSSuccess = student => ({
  type: GET_SCHOOL_FOS_SUCCESS,
  payload: { student }
});
export const getSchoolFOSError = message => ({
  type: GET_SCHOOL_FOS_ERROR,
  payload: { message }
});


export const addSchoolProgram = (data, props) => ({
  type: ADD_SCHOOL_PROGRAM,
  payload: { data, props }
});

export const addSchoolProgramSuccess = student => ({
  type: ADD_SCHOOL_PROGRAM_SUCCESS,
  payload: { student }
});
export const addSchoolProgramError = message => ({
  type: ADD_SCHOOL_PROGRAM_ERROR,
  payload: { message }
});

export const deleteSchoolProgram = (data, props) => ({
  type: DELETE_SCHOOL_PROGRAM,
  payload: { data, props }
});

export const deleteSchoolProgramSuccess = student => ({
  type: DELETE_SCHOOL_PROGRAM_SUCCESS,
  payload: { student }
});
export const deleteSchoolProgramError = message => ({
  type: DELETE_SCHOOL_PROGRAM_ERROR,
  payload: { message }
});

export const addSchoolFos = (data, props) => ({
  type: ADD_SCHOOL_FOS,
  payload: { data, props }
});

export const addSchoolFosSuccess = student => ({
  type: ADD_SCHOOL_FOS_SUCCESS,
  payload: { student }
});
export const addSchoolFosError = message => ({
  type: ADD_SCHOOL_FOS_ERROR,
  payload: { message }
});
export const deleteSchoolFos = (data, props) => ({
  type: DELETE_SCHOOL_FOS,
  payload: { data, props }
});

export const deleteSchoolFosSuccess = student => ({
  type: DELETE_SCHOOL_FOS_SUCCESS,
  payload: { student }
});
export const deleteSchoolFosError = message => ({
  type: DELETE_SCHOOL_FOS_ERROR,
  payload: { message }
});







